export default __webpack_public_path__ + "static/media/poster_web.bf83c1c8.jpg";